<template>
  <div :class="['layout-footer', $route.path == '/' ? 'empty-letter' : '']">
    <span class="footer-text" style="margin-right: 5px"
      >CDI &copy; , 2026</span
    >
  </div>
</template>

<style lang="scss" scoped>
.empty-letter {
  position: absolute;
  bottom: 0;
}
footer {
  position: fixed;
  display: flex;
  left: 0;
  bottom: 0; /* Левый нижний угол */
  padding: 10px;
  /*background: #39b54a;  Цвет фона */

  width: 100%; /* Ширина слоя */
  justify-content: flex-start;
}
</style>
